/* eslint-disable react/prop-types */ // TODO: add props
import Immutable from 'immutable';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import ShareLink from 'edrolo/components/common/ShareLink';
import styles from './styles.scss';
import { Question } from './Question';
import { QUESTION_GROKKED } from '../../constants';
import { Button } from 'edrolo-style-guide';
import { useEffect, useState } from 'react';
import waffle from 'edrolo/utils/Waffle';

export const QuestionWrapper = ({
  classId,
  exam,
  question,
  response,
  isTeacher,
  isLastQuestion,
  onSubmit,
  onSubmitChecklistReflectionItem,
  onSubmitGrok,
  onSubmitMark,
  onQuestionComplete,
}) => {
  const isResponseComplete = response && response.get('completed');

  const isReflectionComplete =
    response && response.get('grokked') !== QUESTION_GROKKED.NO_RESPONSE;

  const isQuestionMarked =
    response && response.get('text_marks_from_student') !== null;

  // The code below supports the "Do it later" button which is displayed for
  // questions with checklists. This is displayed if the user attends to got to
  // the next question without completing the checklist, and is a soft CTA to
  // complete the question before continuing.
  // TODO: Arguably we should be consistent and either remove this for checklists,
  // or display it for all question types
  const [showDoItLaterButton, setShowDoItLaterButton] = useState(false);

  const isChecklistQuestion = [
    EXAM_QUESTION_TYPES.TEXT_CHECKLIST,
    EXAM_QUESTION_TYPES.WORKED_ANNOTATED_IMAGE,
  ].includes(question.get('question_type'));

  const isChecklistComplete =
    response &&
    Immutable.is(
      response
        .getIn(
          ['solution', 'exemplar_response_checklist_items'],
          Immutable.List()
        )
        .map((item) => item.get('id'))
        .toSet(),
      response
        .get('checklist_reflections', Immutable.List())
        .map((reflection) => reflection.get('exemplar_response_checklist_item'))
        .toSet()
    );

  useEffect(() => {
    if (isChecklistQuestion && isChecklistComplete) {
      setShowDoItLaterButton(false);
    }
  }, [response, isChecklistQuestion, isChecklistComplete]);

  // TODO: clean all this up once the waffle flag is gone
  const disableNextQuestionLogicWithAlignedCompletion =
    (!isChecklistQuestion && !isResponseComplete) ||
    (isChecklistQuestion &&
      (!isReflectionComplete || !isQuestionMarked || showDoItLaterButton));
  const legacyDisableNextQuestionLogic =
    !isReflectionComplete || (isChecklistQuestion && showDoItLaterButton);
  const isNextQuestionButtonDisabled = waffle.flag_is_active(
    'questions-self-marking'
  )
    ? disableNextQuestionLogicWithAlignedCompletion
    : legacyDisableNextQuestionLogic;

  return (
    <div className={styles.questionSet} data-test="question-container">
      <h1 id="question-title" className={styles.questionTitle}>
        {`Q${question.get('full_serial')}`}

        {isTeacher ? (
          <span className={styles.shareLink}>
            <ShareLink
              title="To share this question, copy and paste this link:"
              appLabel="exams"
              model="exam"
              objectId={exam.get('id')}
              shareType="question-set-question"
              origin="question-set-question"
              utm_campaign="question-set-question"
              classId={classId}
              queryStringParams={{
                questionId: question.get('id'),
              }}
            >
              <button className="share-link">
                <i className="icon-share-square-o" />
              </button>
            </ShareLink>
          </span>
        ) : question.get('question_type') ===
          EXAM_QUESTION_TYPES.SELECT_MULTI ? (
          <div className={styles.questionTitle}>Select all that apply</div>
        ) : null}
      </h1>

      <Question
        question={question}
        response={response}
        onSubmit={onSubmit}
        onSubmitChecklistReflectionItem={onSubmitChecklistReflectionItem}
        onSubmitGrok={onSubmitGrok}
        onSubmitMark={onSubmitMark}
        isTeacher={isTeacher}
        showIncompleteChecklistWarning={showDoItLaterButton}
      />

      {response && (
        <Button
          disabled={isNextQuestionButtonDisabled}
          onClick={() => {
            if (isChecklistQuestion && !isChecklistComplete) {
              setShowDoItLaterButton(true);
            } else {
              onQuestionComplete();
            }
          }}
          data-test="question-response-nav-button"
        >
          {isLastQuestion ? 'Back to question index' : 'Next question »'}
        </Button>
      )}

      {response && isChecklistQuestion && showDoItLaterButton && (
        <Button
          outline
          className={styles.secondButton}
          onClick={onQuestionComplete}
          data-test="question-response-skip-button"
        >
          {'Iʼll do it later'}
        </Button>
      )}
    </div>
  );
};
